import Link from "next/link"
import classNames from "classnames"

export default function Terms({ terms, className = "", omitPrimary = false }) {
  terms = omitPrimary ? terms.filter((term) => !term.isPrimary) : terms

  const items = terms.map((term, key) => {
    const classes = [
      "px-3 py-2 font-sans text-xs font-medium tracking-wider no-underline uppercase rounded whitespace-nowrap leading-1 bg-black-100/10 hover:bg-black-100/20"
    ]

    let link = (
      <Link href={term.url} prefetch={false} className={classNames(classes)}>
        {term.label}
      </Link>
    )

    if (!term.url) {
      link = <a className={classNames(classes)}>{term.label}</a>
    }

    return (
      <li className="mr-3 mb-4" key={"article-terms-" + key}>
        {link}
      </li>
    )
  })

  if (items.length === 0) {
    return null
  }

  return (
    <ul
      className={`box-content flex flex-wrap mx-auto max-w-screen-sm post-terms no-print ${className}`}>
      {items}
    </ul>
  )
}
